import { render, staticRenderFns } from "./FpuiPackageEditorGeneral.vue?vue&type=template&id=57736aaa&lang=pug&"
import script from "./FpuiPackageEditorGeneral.vue?vue&type=script&lang=js&"
export * from "./FpuiPackageEditorGeneral.vue?vue&type=script&lang=js&"
import style0 from "./FpuiPackageEditorGeneral.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports